/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMultiplyScalar } from '../../factoriesAny.js';
export var multiplyScalarDependencies = {
  typedDependencies,
  createMultiplyScalar
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesMultiplyScalar.generated.js
// module id = 36
// module chunks = 2